import { getBackendBoolean } from '@Sage/ssm-utils/backendScalars';

/**
 * Maps backend task contact fields to the fuzzySearchSingle CRUD value.
 * Ignores `data.contact` when it is an attendees array from processAttendeesForWeb.
 */
export function mapTaskContactForCrud(data) {
    const contactId = data?.idContact ?? data?.idContacto ?? data?.IdContact;
    const contactName =
        (typeof data?.contact === 'string' && data.contact) ||
        (typeof data?.contactName === 'string' && data.contactName) ||
        (typeof data?.contacto === 'string' && data.contacto) ||
        '';

    if (!contactId || contactId === '-1') return null;

    return contactName ? { value: contactId, label: contactName } : contactId;
}

/**
 * Tasks use fuzzySearchSingle `contact`; events keep the attendees `contact` array.
 * Prefer a caller-normalized `isTarea` boolean; fall back to parsing `data.isTarea`.
 */
export function resolveAgendaContactForCrud(data, attendeesContact, isTarea) {
    const isTask = typeof isTarea === 'boolean' ? isTarea : getBackendBoolean(data?.isTarea);
    if (isTask) {
        return mapTaskContactForCrud(data);
    }
    return attendeesContact;
}
